<template>
    <ecranproduction poste="bar" />
</template>

<script>
/* eslint-disable */
/**
 * Page /bar.
 *
 * Jumelle de /cuisine : même socle, autre poste. Le backend route les lignes du
 * ticket par categorieplat (BOISSON et DESSERT vers le bar, PLAT vers la
 * cuisine), numérote les bons BAR-001 et applique le dispatcher de charge
 * séparément pour chaque poste. Rien de spécifique n'est nécessaire ici.
 *
 * Un même navigateur peut afficher les deux écrans : chacun garde son propre
 * jeton, sous une clé distincte (voir HABILLAGE dans le socle).
 */
import ecranproduction from "@/components/views/pages/screen/ecranproduction";

export default {
    name: "barindex",
    components: { ecranproduction },
};
</script>
